<template>
  <div class="header-top">
    <svg slot="image"  class="icon" aria-hidden="true" @click="$route.path=='/purchase'?$router.push('/index'):''">
      <use xlink:href="#icon-logo2"></use>
    </svg>
    <div class="language" @click="moreModel = true"> <i class="iconfont icon-a-gengduo1"></i></div>
    <van-popup v-model="vanPopupShow" round position="bottom" :style="{ height: '50%' }" class="language-popup">
      <div class="popup-title">{{ $t('300063') }}
        <van-icon name="cross" @click="vanPopupShow = false"/>
      </div>
      <div class="language-list">
        <p class="list-item" v-for="(item,index) in languageList" :key="index" @click="changeLanguage(item)">
          {{ item.name }}
          <van-icon name="success" v-show="language == item.language"/>
        </p>
      </div>
    </van-popup>
       <van-popup v-model="moreModel" round position="bottom" :style="{ height: '50%' }" class="language-popup">
      <div class="popup-title more-title">
        <van-icon name="cross" @click="moreModel = false"/>
      </div>
      <div class="more-user" v-if="token">
        <p v-if="user.email&&user.iphone">{{user.email}}</p>
        <p v-else-if="user.email">{{user.email}}</p>
        <p v-else>{{user.iphone}}</p>
        <p>ID:{{user.id}}<i @click="handleCopy" :data-clipboard-text='user.id' class="copy iconfont icon-fuzhi"></i></p>
      </div>
      <div class="more-language">
        <span>{{ $t('300063') }}</span> <span @click="vanPopupShow = true">{{ languageName }} <i class="iconfont icon-xiala"></i>
        </span>
        </div>
        <div @click="$router.push('/download')" class="more-download">
        <span>{{$t('300332')}}</span>
        </div>
       <div v-if="!token" class="btn_box">
        <van-button @click="toLogin">{{$t('300169')}}</van-button>
        <van-button @click="toRegister">{{$t('300041')}}</van-button>
       </div>
       </van-popup>
  </div>
</template>

<script>
import {Icon, Popup,Button,Toast} from 'vant'
import {getLanguageList} from "../api/user";
import {mapGetters} from 'vuex'
import {setCookie} from '@/utils/auth'
import Clipboard from 'clipboard'
export default {
  name: "headerTop",
  components: {
    vanIcon: Icon,
    vanPopup: Popup,
    VanButton:Button
  },
  data() {
    return {
      vanPopupShow: false,
      languageList: [],
      moreModel:false
    }
  },
  computed: {
    ...mapGetters(['languageName', 'language','token','user'])
  },
  created() {
    this.getLanguageList()
   if(this.token){
     this.$store.dispatch('GetInfo',this.token)
   }
  },
  methods: {
      handleCopy() {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        Toast.success(this.$t('300027'))
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        Toast.fail(this.$t('300028'))
        // 释放内存
        clipboard.destroy()
      })
    },
    toLogin(){
      this.moreModel = false;
      this.$router.push('/login')
    },
    toRegister(){
       this.moreModel = false;
      this.$router.push('/register')
    },
    getLanguageList() {
      getLanguageList().then(res => {
        this.languageList = res.data || []
      })
    },
    changeLanguage(item) {
      this.$store.dispatch('setLanguage', item.language)
      this.$store.dispatch('setLanguageName', item.name)
      this.vanPopupShow = false
      setTimeout(() => {
        this.$i18n.locale = item.language
        
      },1000)
      location.reload()
    },
  }

}
</script>

<style lang="scss" scoped>
@import "../style/mixin";
@import "../assets/css/variableName";

.header-top {
  position: fixed;
  top: 0;
  width: 100%;
  height: torem(46);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0 torem(16);
  z-index: 9;

  svg {
    @include wh(torem(99.7), torem(16));
  }

  .language {
    @include sc(torem(16), #fff);
    line-height: 1.5;

    i {
      font-size: torem(18);
      // margin-left: torem(8);
      color: #000922;
    }
  }
}
.more-download{
  height: torem(63);
  width: 100%;
  // padding: torem(24) torem(28);
  line-height: torem(63);
  
  border-bottom: torem(1) solid #EFEFEF;
  span{
    font-size: torem(15);
    margin: 0 torem(28);
    color:#333333 ;
  }
}
[dir='ltr']{
  .more-user{
    p{
      i{
        margin-left: torem(8);
      }
    }
  }
}
[dir='rtl']{
  .more-user{
    p{
      i{
       margin-left: torem(8);
      }
    }
  }
}
.more-user{
  padding: torem(16) 0;
  border-bottom: torem(1) solid #EFEFEF;
  height: torem(78);
  box-sizing: border-box;
  p{
    margin: 0 torem(28);
    &:first-child{
      font-size: torem(20);
      line-height: torem(23.44);
      color: #333333 ;
    }
    &:last-child{
      font-size: torem(12);
      color: #666666;
      margin-top: torem(8);
      i{
        font-size: torem(14);
      }
    }
  }
}
.more-language{
  height: torem(63);
  width: 100%;
  padding: torem(24) torem(28);
  border-bottom: torem(1) solid #EFEFEF;
  display: flex;
  justify-content: space-between;
  align-items: center;
 span{
  color: #333333;
   font-size: torem(15);
   i{
    font-size: torem(12);
   }
 }
}
.btn_box{
  width: 100%;
  height: torem(144);
  display: flex;
  flex-direction: column;
  padding: torem(24) 0;
  box-sizing: border-box;
  .van-button{
     width: torem(319);
      height: torem(44);
      font-size: torem(16);
      color: #333333;
      border: none;
      margin: 0 auto;
    &:last-child{
     margin-top: torem(8);
     background: #FFC72B;
     border-radius: torem(4);
    }
  }
}
.language-popup {
  .popup-title {
    display: flex;
    justify-content: space-between;
    padding: torem(24) torem(16) torem(16);
    @include sc(torem(18), #333);
  }
.more-title{
 justify-content: flex-end;
  padding: torem(24) torem(16) torem(8);
  }
  .language-list {
    z-index: 99;

    .list-item {
      padding: torem(16) torem(28);
      @include sc(torem(15), #333);
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/ .van-icon {
        @include sc(torem(20), #FFC72B);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/headerTop.vue